import styled from "styled-components";
import bottomImage from "assets/images/Union.svg";

const PolicyCardWrapper = styled.div`
  .container-fluid {
    text-align: initial;
  }
  .container-fluid-rtl {
    text-align: right;
  }
  .radioDiv-rtl {
    padding-right: 25px;
    padding-top: 40px;
  }
  .radioDiv-discount-rtl {
    padding-right: 25px;
    padding-top: 50px;
  }
  .header-height {
    height: 100%;
  }
  .header-height-discount {
    max-height: 214px;
  }
  .p-radiobutton .p-radiobutton-box.p-highlight {
    background: #fff !important;
    border-color: #fff !important;
  }
  .p-radiobutton-box.p-highlight .p-radiobutton-icon {
    transform: translateZ(0) scale(1, 1);
    visibility: visible;
  }
  .p-radiobutton .p-radiobutton-box .p-radiobutton-icon {
    width: 12px;
    height: 12px;
    transition-duration: 0.2s;
    background-color: black !important;
  }
  .activeColor {
    color: #fff !important;
  }
  .card {
    width: auto;
    padding: 20px;
    border-radius: 12px;
  }
  .p-card {
    background: url(${bottomImage}), #fff;
    background-repeat: no-repeat !important;
    background-size: contain;
    border: 1px solid #d9dce1;
    border-radius: 12px;
    box-shadow: none;
    background-position: right bottom !important;
    padding: 10px 20px;
    .headerText {
      padding: 0;
      width: 70%;
    }
    .header-help {
      width: 30%;
      text-align: center;
    }
    .p-card-header {
      margin-bottom: 0px;
    }
    .title {
      font-weight: 800;
      font-size: 1rem;
      color: #1a1c1f;
      margin-bottom: 4px;
      span {
        font-weight: 500;
      }
    }
    .tagDiv {
      margin-top: 7px;
      .pi {
        color: #4c565c;
      }
    }
    .subtitleText {
      font-weight: 400;
      font-size: 0.9rem;
      margin-bottom: 14px;
      color: #4c565c;
    }
    .rec-card {
      position: absolute;
      width: 115px;
      height: 25px;
      border-radius: 15px 7px 0px 0px;
      padding: 3px 0px;
      text-align: center;
      color: #fff;
      font-weight: 800;
      font-size: 0.8rem;
      top: -25px;
      right: 17px;
      background: #2a293e;
      border: none;
    }
    .rec-card::after {
      content: "";
      display: block;
      position: absolute;
      border-color: transparent #2a293e;
      border-style: solid;
      right: 50px;
      border-width: 10px 0px 10px 10px;
      top: 78%;
      transform: rotate(90deg);
    }
    .claim-price {
      padding: 0;
    }
    .amount {
      font-weight: 800;
      font-size: 1.2rem;
      color: #4c565c;
    }
    .currency {
      font-weight: 500;
      font-size: 0.875rem;
      color: #4c565c;
    }
    .vat {
      font-weight: 500;
      font-size: 0.625rem;
      color: #4c565c;
    }
    @media screen and (min-width: 768px) {
      min-height: 80px;
    }
  }
  .activeCard {
    padding: 10px 20px;
    width: auto;
    display: block;
    flex-direction: column;
    border-radius: 12px;
    background: url(${bottomImage}), #6b47f5;
    background-repeat: no-repeat !important;
    background-position: right bottom;
    position: relative;
    .tagDiv .pi {
      color: #fff;
    }
  }
  .activeCard {
    padding: 10px 20px;
    width: auto;
    display: block;
    flex-direction: column;
    border-radius: 12px;
    background: url(${bottomImage}), ${(props) => props.businessColor};
    background-repeat: no-repeat;
    background-position: right bottom;
    position: relative;
    .tagDiv .pi {
      color: #fff;
    }
  }
  .p-radiobutton .p-radiobutton-box {
    width: 35px;
    height: 32px;
    background: #f2f3f5;
    pointer-events: none;
    border: 2px solid #f2f3f5;
  }
  .p-radiobutton {
    width: 32px;
    height: 32px;
  }
  .radioDiv-rtl {
    padding: 0px !important;
  }
  .radioDiv-discount-rtl {
    padding: 0px !important;
  }
  .p-card .p-card-content {
    margin-top: 0px;
    padding: 0.25rem 0;
  }
  .p-card .p-card-body {
    padding: 0;
  }

  @media only screen and (max-width: 600px) {
    .header-height {
      height: 95px;
    }
    .header-height-discount {
      height: 50px;
    }
    .card {
      margin-bottom: 40px;
      flex-direction: column;
    }
    .activeCard {
      margin-bottom: 40px;
      flex-direction: row;
      display: block;
      background: #6b47f5;
    }
    .activeCard {
      margin-bottom: 40px;
      flex-direction: row;
      display: block;
      background: ${(props) => props.businessColor} !important;
    }
    .radio {
      display: none;
    }
    .headerText {
      width: max-content;
    }
    .p-card .tagDiv {
      margin-top: 0px;
    }
    .p-card .p-card-header {
      margin-bottom: 0px;
      width: 100%;
    }
    .p-card .p-card-body {
      width: 50%;
    }
    .align-items-end {
      margin: -7px 0px 0 10px;
    }
    .p-card .title {
      font-size: 0.75rem;
    }
    .price-area {
      margin: 0;
    }
    .p-card .amount {
      font-size: 1.2rem;
    }
  }

  @media only screen and (max-width: 576px) {
  }
`;

export default PolicyCardWrapper;
